/**
 * When we click the "Pay With PayPal" button on the subscribe page, then
 * we should add the selected plan to the URL.
 */
$(document).on('submit', '.js-paypal-subscribe-form', function(e) {
  let form = $(this);
  let path = $(form).attr('action');
  let isYearly = $('input[name="yearly"],input[id="yearly"]').val() == "true";
  let plan = isYearly ? "yearly" : "monthly";
  $(form).find('input[name=plan]').val(plan);
});
